export default {
    namespace: true,
    state: {
        calculateMapFromIndexPage: false
    },

    actions: {

    },

    mutations: {
        setCalculateMapFromIndexPage(state, calculateMapFromIndexPage) {
            state.calculateMapFromIndexPage = calculateMapFromIndexPage;
        }
    },

    getters: {
        calculateMapFromIndexPage: state => state.calculateMapFromIndexPage
    }
};